module.exports = __webpack_public_path__ + "img/tile-effects_cn.dd9c1af.jpg";